import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/taskpane.html',
    name: 'addin',
    component: () => import('../components/AddIn.vue'),
    meta: { title: 'gender app Add-in · Gendernswerte Formulierungen sichtbarmachen und Alternativen finden' }
  },
  {
    path: '/magiclink/:username/:token',
    name: 'magic_link',
    component: () => import('../components/MagicLink.vue'),
    meta: { title: 'gender app Add-in · Magic Link' }
  },
  {
    path: '*',
    name: 'addin',
    component: () => import('../components/AddIn.vue'),
    meta: { title: 'gender app Add-in · Gendernswerte Formulierungen sichtbarmachen und Alternativen finden' }
  }
  //   component: () => import('../components/404.vue'),
  //   meta: { title: 'gender app Add-in · Gendernswerte Formulierungen sichtbarmachen und Alternativen finden' }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})
export default router
